[
  {
    "id": "round",
    "x": 16,
    "y": 20,
    "w": 238,
    "h": 94
  },
  {
    "id": "logo",
    "x": 288,
    "y": 8,
    "w": 404,
    "h": 250
  },
  {
    "id": "sticker.l",
    "x": 56,
    "y": 138,
    "w": 174,
    "h": 132
  },
  {
    "id": "sticker.r",
    "x": 798,
    "y": 178,
    "w": 142,
    "h": 136
  },
  {
    "id": "seat4.ring",
    "x": 452,
    "y": 258,
    "w": 192,
    "h": 176
  },
  {
    "id": "seat1.ring",
    "x": 18,
    "y": 282,
    "w": 158,
    "h": 152
  },
  {
    "id": "seat2.ring",
    "x": 176,
    "y": 282,
    "w": 144,
    "h": 152
  },
  {
    "id": "seat3.ring",
    "x": 320,
    "y": 282,
    "w": 132,
    "h": 152
  },
  {
    "id": "seat5.ring",
    "x": 644,
    "y": 282,
    "w": 136,
    "h": 152
  },
  {
    "id": "seat6.ring",
    "x": 780,
    "y": 282,
    "w": 148,
    "h": 152
  },
  {
    "id": "seat1.pill",
    "x": 21,
    "y": 393,
    "w": 148,
    "h": 85,
    "shape": {
      "kind": "pill",
      "n": [
        41,
        413,
        148,
        457
      ],
      "glow": 20
    }
  },
  {
    "id": "seat2.pill",
    "x": 166,
    "y": 395,
    "w": 143,
    "h": 82,
    "shape": {
      "kind": "pill",
      "n": [
        186,
        415,
        288,
        456
      ],
      "glow": 20
    }
  },
  {
    "id": "seat3.pill",
    "x": 309,
    "y": 395,
    "w": 145,
    "h": 82,
    "shape": {
      "kind": "pill",
      "n": [
        329,
        415,
        433,
        456
      ],
      "glow": 20
    }
  },
  {
    "id": "seat4.pill",
    "x": 453,
    "y": 398,
    "w": 186,
    "h": 88,
    "shape": {
      "kind": "pill",
      "n": [
        473,
        418,
        618,
        465
      ],
      "glow": 20
    }
  },
  {
    "id": "seat5.pill",
    "x": 634,
    "y": 395,
    "w": 143,
    "h": 82,
    "shape": {
      "kind": "pill",
      "n": [
        654,
        415,
        756,
        456
      ],
      "glow": 20
    }
  },
  {
    "id": "seat6.pill",
    "x": 777,
    "y": 395,
    "w": 143,
    "h": 82,
    "shape": {
      "kind": "pill",
      "n": [
        797,
        415,
        899,
        456
      ],
      "glow": 20
    }
  },
  {
    "id": "question",
    "x": 46,
    "y": 460,
    "w": 838,
    "h": 262,
    "shape": {
      "kind": "pill",
      "n": [
        66,
        480,
        864,
        701,
        36
      ],
      "glow": 20
    }
  },
  {
    "id": "row1",
    "x": 108,
    "y": 702,
    "w": 724,
    "h": 90
  },
  {
    "id": "row2",
    "x": 108,
    "y": 792,
    "w": 724,
    "h": 86
  },
  {
    "id": "row3",
    "x": 108,
    "y": 878,
    "w": 724,
    "h": 88
  },
  {
    "id": "row4",
    "x": 108,
    "y": 966,
    "w": 724,
    "h": 84
  },
  {
    "id": "row5",
    "x": 108,
    "y": 1050,
    "w": 724,
    "h": 88
  },
  {
    "id": "row6",
    "x": 108,
    "y": 1138,
    "w": 724,
    "h": 86
  },
  {
    "id": "alltheway",
    "x": 97,
    "y": 1207,
    "w": 747,
    "h": 159,
    "shape": {
      "kind": "pill",
      "n": [
        117,
        1227,
        823,
        1345
      ],
      "glow": 20
    }
  },
  {
    "id": "cta",
    "x": 88,
    "y": 1347,
    "w": 763,
    "h": 155,
    "shape": {
      "kind": "pill",
      "n": [
        110,
        1369,
        828,
        1479
      ],
      "glow": 22
    }
  },
  {
    "id": "callit",
    "x": 138,
    "y": 1471,
    "w": 665,
    "h": 121,
    "shape": {
      "kind": "pill",
      "n": [
        158,
        1491,
        782,
        1571
      ],
      "glow": 20
    }
  }
]
